<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<h1 class="title">The Eleven of Diamonds</h1>
<p class="author">A Miles Standish Rice Mystery</p>
<p class="author1">Baynard Kendrick</p>
<div class="img_container1">
<img alt="image" src="images/logo3.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?7a6460d0